/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomLayout from "../../../Core/Layout/CustomLayout";
import CustomKPI from "../../../Core/Components/CustomKpi";
import {
  chargingStationColumns,
  chargingStationData,
  CSKpiData,
} from "./constants";
import Header from "./Header";
import CustomTable from "../../../Core/Components/CustomTable";
import { getTableContainerHeight } from "../../../Utils/getTableContainerHeight";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import ChargingHistoryDrawer from "./ChargingHistoryDrawer";
import { updateHub } from "../../../Redux/Slices/hubs.slice";
import { getChargerKPI } from "../../../Redux/APIs/chargersAPI";

const LOCAL_DEFAULT_LIMIT = 10;

const ChargingStationScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedHub, historyDrawer } = useSelector((state) => state.hubs);

  const { kpi } = useSelector((state) => state.chargers);

  const [showKpi, setShowKpi] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    status: [],
  });

  const tableContainerRef = useRef();

  const getTableContainerStyle = () => {
    if (chargingStationData.length) {
      if (showKpi) return "h-[calc(100vh-72px-61px-40px)] overflow-y-scroll";
      return "h-[calc(100vh-72px-160px-61px-40px)] overflow-y-scroll";
    }
    return "h-[calc(100vh-72px-160px-61px-40px)]";
  };

  // fetch the charger kpi data
  useEffect(() => {
    dispatch(getChargerKPI());
  }, [dispatch]);

  return (
    <CustomLayout
      pageName={selectedHub?.hubName || ""}
      nestedName="Charging Station"
    >
      <div className="bg-background">
        <div className="flex items-center justify-between w-full h-40 p-6 gap-x-6">
          {CSKpiData(kpi)?.map((i) => (
            <CustomKPI
              key={i.title}
              image={i?.image}
              title={i?.title}
              count={i?.count}
              total={i?.total}
              icon={i?.icon}
              redirect={i?.redirect}
              handleOnClick={() => {
                if (i?.id === 3) {
                  navigate("/service");
                }
              }}
            />
          ))}
        </div>

        <div
          className={`absolute w-[calc(100vw-72px)] ${
            showKpi ? "-translate-y-[160px]" : ""
          }  transition-transform duration-500`}
        >
          <Header
            showKpi={showKpi}
            setShowKpi={setShowKpi}
            search={search}
            setSearch={setSearch}
            filters={filters}
            setFilters={setFilters}
            setCurrentPage={setCurrentPage}
          />

          <div className={getTableContainerStyle()} ref={tableContainerRef}>
            <CustomTable
              // scrollX={0}
              disableScroll
              columns={chargingStationColumns}
              data={chargingStationData}
              emptyState={<ChargerIcon className="text-dark-grey-text" />}
              emptyStateHeight={getTableContainerHeight(tableContainerRef)}
              rowClassName="group cursor-pointer"
              pagination={{
                pageSize: LOCAL_DEFAULT_LIMIT,
                total: chargingStationData.length,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                },
                current: currentPage,
                itemRender: (current, type, originalElement) => {
                  const lastPage = chargingStationData.length / current;

                  if (type === "prev" && current === 0) {
                    return (
                      <button
                        type="button"
                        className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                        style={{
                          pointerEvents: "none",
                        }}
                      >
                        <ChevronIcon className="stroke-dark-gray" />
                      </button>
                    );
                  }

                  if (type === "prev" && current > 0) {
                    return (
                      <button
                        type="button"
                        className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      >
                        <ChevronIcon className="stroke-dark-gray" />
                      </button>
                    );
                  }

                  if (type === "next" && lastPage <= 10) {
                    return (
                      <button
                        type="button"
                        className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                        style={{ pointerEvents: "none" }}
                      >
                        <ChevronIcon className="stroke-dark-gray" />
                      </button>
                    );
                  }

                  if (type === "next") {
                    return (
                      <button
                        type="button"
                        className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      >
                        <ChevronIcon className="stroke-dark-gray" />
                      </button>
                    );
                  }

                  return originalElement;
                },
              }}
            />
          </div>
        </div>
      </div>

      <ChargingHistoryDrawer
        visible={historyDrawer}
        onCancel={() => {
          dispatch(
            updateHub({
              key: "historyDrawer",
              value: false,
            }),
          );

          dispatch(
            updateHub({
              key: "currentCharger",
              value: {},
            }),
          );
        }}
      />
    </CustomLayout>
  );
};

export default ChargingStationScreen;
